import React, { Component } from 'react';
import Select from 'react-select';
import '../../Modal.css';
import { connect } from 'react-redux';
import { updateSelectedSite } from '../../../../actions/adminActions/sitesActions';
import { sites } from '../../../../apis/backend';

class EditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      cities: [],
      name: ''
    };
  }

  clearState() {
    this.setState({
      id: '',
      cities: [],
      name: ''
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.selectedSite !== this.props.selectedSite && this.props.selectedSite !== 0) {
      const site = this.props.sites.find((obj) => obj.id === this.props.selectedSite);
      if (site) {
        this.setState({
          cities: site.cities.map((x) => ({ value: x.id, label: x.name })),
          name: site.name
        });
      }
    }
  }

  async siteRequest() {
    try {
      await sites
        .patch(
          `/${this.props.selectedSite}`,
          {
            cities: this.state.cities.map((city) => city.value),
            name: this.state.name
          },
          { headers: { authorization: this.props.employeeToken } }
        )
        .then(this.clearState())
        .catch((response) => {
          console.log(response);
          alert('Sorry, an error occurred. Please check your entries.');
        });
    } catch (err) {
      console.log('Request Failed.');
    }
  }

  render() {
    const cityOptions = this.props.cities.map((city) => {
      const option = {
        value: city.id,
        label: city.name
      };
      return option;
    });
    return (
      <div id="exampleModal" className="modal fade" style={{ overflow: 'scroll' }}>
        <div className="modal-dialog modal-dialog-centered lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Site</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="input-group input-group-sm mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Site Name
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  value={this.state.name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
              </div>
              <div className="input-group input-group-sm mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Cities
                  </span>
                </div>
                <Select
                  name="SiteCities"
                  id="SiteCities"
                  className="multiselector"
                  isMulti
                  value={this.state.cities}
                  options={cityOptions}
                  onChange={(e) => {
                    this.setState({ cities: e });
                  }}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => this.clearState()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-dark"
                data-dismiss="modal"
                onClick={() => {
                  this.siteRequest();
                }}
                disabled={!this.state.name != ''}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  sites: state.admin.admin.sites,
  cities: state.admin.admin.cities,
  selectedSite: state.admin.sites.selectedSite,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, { updateSelectedSite })(EditModal);
